import { render, staticRenderFns } from "./EleGallery.vue?vue&type=template&id=5268d882&"
import script from "./EleGallery.vue?vue&type=script&lang=js&"
export * from "./EleGallery.vue?vue&type=script&lang=js&"
import style0 from "./EleGallery.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports